var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopyNodeIcon = function SvgCopyNodeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3AACC8",
    fillRule: "evenodd",
    d: "M12.79 2.41A1.8 1.8 0 0 1 14.4 4.2v5.2a1.8 1.8 0 0 1-1.8 1.8h-1.8V8.497a2.4 2.4 0 0 0-.703-1.697L7.6 4.303a2.4 2.4 0 0 0-1.12-.633 1.8 1.8 0 0 1 1.53-1.26A1.8 1.8 0 0 1 9.8.8H11a1.8 1.8 0 0 1 1.79 1.61M9.2 2.6a.6.6 0 0 1 .6-.6H11a.6.6 0 0 1 .6.6v.2H9.2z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3AACC8",
    d: "M2.8 4.8A1.2 1.2 0 0 0 1.6 6v7.2a1.2 1.2 0 0 0 1.2 1.2h5.6a1.2 1.2 0 0 0 1.2-1.2V8.497a1.2 1.2 0 0 0-.351-.849L6.752 5.151a1.2 1.2 0 0 0-.849-.351z"
  })));
};
export { SvgCopyNodeIcon as ReactComponent };
export default __webpack_public_path__ + "12bd83528727119a680d9f9d23589480.svg";